import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { UserRole } from 'utils/bankStatements';

export function useAccountNumberPermission() {
  const userRole = useSelector((state) => get(state, 'bankStatements.settings.userRole'));
  const [canEdit, setCanEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function checkPermission() {
      try {
        setCanEdit(userRole === UserRole.Admin || userRole === UserRole.Underwriter);
      } catch (error) {
        console.error('Error checking permissions:', error);
        setCanEdit(false);
      } finally {
        setIsLoading(false);
      }
    }
    checkPermission();
  }, []);

  return { canEdit, isLoading };
}
